import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./router/AppRouter";
import AuthRoutes from "./router/AuthRouter";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastContainer } from 'react-toastify';
import "./App.css"
function App() {
  return (
    <AuthProvider>
      <Router>
        <MainRoutes />
        <ToastContainer/>
      </Router>
    </AuthProvider>
  );
}

const MainRoutes = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="h-screen bg-gray-100">
      <AppRoutes isAuthenticated={isAuthenticated} /> 
       <AuthRoutes />
    </div>
  );
};

export default App;
